import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { IModalService } from 'angular-ui-bootstrap';
import { IConfirmationPasswordPopupSettings } from '../../../../app.admin/modules/notifications/shopper-notifications.service';
import { IPopupSettings } from '../models';

export class PopupService {
    public static $inject = ['$uibModal', '$document'];
    constructor(
        private $uibModal: IModalService,
        private $document: ng.IDocumentService,
    ) { }

    public confirm(settings: IPopupSettings) {
        return this.showConfirm(settings).result;
    }

    public info(settings: IPopupSettings) {
        return this.showInfo(settings).result;
    }

    public showConfirm(settings: IPopupSettings) {
        return this.$uibModal.open({
            component: 'confirmPopup',
            resolve: {
                settings: () => settings
            },
            windowClass: settings.classPopup || '',
            size: 'sm',
            backdrop: (settings.closeOnClickOutside == null) ? true :
                ((settings.closeOnClickOutside === false) ? 'static' : true)
        });
    }

    public showPrivacyNotification(settings: IPopupSettings) {
        return this.$uibModal.open({
            component: 'alertPopup',
            resolve: {
                settings: () => settings
            },
            windowClass: 'privacy-notofication-popup',
            size: 'sm',
            backdrop: false,
            keyboard: false,
            appendTo: settings.appendTo || this.$document.find('body')
        }).result;
    }

    public alert(settings: IPopupSettings) {
        return this.$uibModal.open({
            component: 'alertPopup',
            resolve: {
                settings: () => settings
            },
            windowClass: settings.classPopup || '',
            size: 'sm',
            appendTo: settings.appendTo || this.$document.find('body'),
            backdrop: (settings.closeOnClickOutside == null) ? true :
                ((settings.closeOnClickOutside === false) ? 'static' : true)
        }).result;
    }

    public confirmPassword(settings: IConfirmationPasswordPopupSettings): ng.IPromise<string> {
        return this.$uibModal.open({
            component: 'confirmationPassword',
            resolve: { settings: () => settings },
            size: 'sm'
        }).result;
    }

    public openModalByName(componentName: string, cssClass: string, data: object): ng.IPromise<string> {
        return this.$uibModal.open({
            component: componentName,
            windowClass: cssClass,
            resolve: { data: () => data },
        }).result;
    }

    private showInfo(settings: IPopupSettings) {
        return this.$uibModal.open({
            component: 'infoPopup',
            resolve: {
                settings: () => settings
            },
            windowClass: settings.classPopup || '',
            size: 'sm',
            backdrop: (settings.closeOnClickOutside == null) ? true :
                ((settings.closeOnClickOutside === false) ? 'static' : true)
        });
    }
}

angular.module('app.common').service('popupService', PopupService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/popup.service.ts